<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-detalles-pagos-universidades"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../utils/funciones';

export default {
  name: 'ListadoDetallesPagosUniversidades',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'N° DOCUMENTO',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.estudiante.numeroDocumento',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PRIMER APELLIDO',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.estudiante.primerApellido',
          minWidth: 180,
        },
        {
          headerName: 'SEGUNDO APELLIDO',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.estudiante.segundoApellido',
          minWidth: 180,
        },
        {
          headerName: 'NOMBRES',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.estudiante.nombres',
          minWidth: 200,
        },
        {
          headerName: 'PROGRAMA',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.programa.nombreCompuesto',
          minWidth: 400,
          maxWidth: 400,
        },
        {
          headerName: 'SEDE',
          field: 'detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.programa.sede.nombre',
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerName: 'GÉNERO',
          cellRenderer: (params) => {
            const genero =
              params?.data?.detalleSolicitudPago?.inscripcionProgramaUniversidad?.inscripcion?.estudiante?.sexo;

            return genero === 'M' ? 'MASCULINO' : 'FEMENINO';
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CELULAR',
          cellRenderer: (params) => {
            const estudiante =
              params?.data?.detalleSolicitudPago?.inscripcionProgramaUniversidad?.inscripcion?.estudiante;
            const celular = estudiante?.telefono1 || estudiante?.telefono2;

            return celular || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CORREO',
          cellRenderer: (params) => {
            const correo =
              params?.data?.detalleSolicitudPago?.inscripcionProgramaUniversidad?.inscripcion?.estudiante?.email;

            return correo || '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'PROFESIÓN',
          cellRenderer: (params) => {
            const profesiones =
              params?.data?.detalleSolicitudPago?.inscripcionProgramaUniversidad?.inscripcion?.estudiante?.profesiones;

            return profesiones?.length ? profesiones[0].nombre : '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'UNIV. TITULACIÓN',
          cellRenderer: (params) => {
            const universidad =
              params?.data?.detalleSolicitudPago?.inscripcionProgramaUniversidad?.inscripcion?.estudiante?.institucion
                ?.nombre;

            return universidad || '-';
          },
          minWidth: 450,
        },
        {
          headerName: 'OBSERVACIÓN',
          field: 'observacion',
          minWidth: 250,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-detalles-pagos-universidades {
  height: calc(var(--vh, 1vh) * 100 - 32rem);
}
</style>
  